module.exports = __webpack_public_path__ + "img/arch_widget.75027f01.jpg";